import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { CatalogPourbackReason } from "../models/CatalogPourbackReason";

export const getCatalogPourbackReasons = async () => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [{ name: "IncludeInactives", value: true }];

  return await apiService.callV2("[STEEL].[GetPourbackReasons]", parameters);
};
export const upsertPourbackReason = async (pourback: CatalogPourbackReason) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "PourbackReasonId", value: pourback.PourbackReasonId },
    { name: "PourbackReasonName", value: pourback.PourbackReasonName },
    { name: "Enabled", value: pourback.Enabled },
  ];

  return await apiService.callV2("[STEEL].[UpsertPourbackReason]", parameters);
};
export const deletePourbackReason = async (PourbackId: number | null) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "PourbackReasonId", value: PourbackId },
  ];

  return await apiService.callV2("[STEEL].[DeletePourbackReason]", parameters);
};
